import { render, staticRenderFns } from "./DialogIdea.vue?vue&type=template&id=46d5ba9d"
import script from "./DialogIdea.vue?vue&type=script&lang=js"
export * from "./DialogIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46d5ba9d')) {
      api.createRecord('46d5ba9d', component.options)
    } else {
      api.reload('46d5ba9d', component.options)
    }
    module.hot.accept("./DialogIdea.vue?vue&type=template&id=46d5ba9d", function () {
      api.rerender('46d5ba9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/componentsCSG/DialogIdea.vue"
export default component.exports